import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-screen-2xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-xl font-heading font-bold text-foreground-950">
            <span className="text-primary-500">韩</span>国漫画网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
              location.pathname === '/'
                ? 'text-primary-500 bg-primary-50'
                : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
            }`}
          >
            首页
          </Link>
          {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
              location.pathname === '/about'
                ? 'text-primary-500 bg-primary-50'
                : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-48 pl-9 pr-3 py-2 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-foreground-950"
          aria-label="菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          <div className="flex flex-col gap-1">
            <Link to="/" className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg whitespace-nowrap">首页</Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg whitespace-nowrap">关于我们</Link>
          </div>
          <div className="mt-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-3 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}